import AncillaryUIModel from './ancillary';

class ExtraBagsAncillaryMap {
  constructor(ancillaries = []) {
    const ancillaryCollection = ancillaries._collection;

    for (const key in ancillaryCollection) {
      if (ancillaryCollection.hasOwnProperty(key)) {
        const ancillary = ancillaryCollection[key];
        ancillaryCollection[key] = new AncillaryUIModel(ancillary);
      }
    }

    this._ancillaries = ancillaryCollection;
  }

  /**
   * @return {Object}
   */
  getAllAncillaries() {
    return this._ancillaries;
  }

  /**
   * @return {Array}
   */
  getAllAncillariesAsArray() {
    return Object.keys(this._ancillaries).map(key => {
      if (this._ancillaries.hasOwnProperty(key)) {
        return this._ancillaries[key];
      } else {
        return false;
      }
    });
  }

  /**
   * Return the total price of bags up to a specified tier
   * @param  {Number} tier - extra bag tier (from 0 - 7)
   * @return {Number}
   */
  getCumulativePriceByTier(tier, ancillaries) {
    let total = 0;
    const extraBags = ancillaries || this._ancillaries;

    for (const key in extraBags) {
      const keyNum = parseInt(key, 10);
      if (this._ancillaries.hasOwnProperty(key) && keyNum <= tier  ) {
        const extraBag = this._ancillaries[key];
        total += extraBag.currency.total;
      }
    }

    return total;
  }
}

export default ExtraBagsAncillaryMap;
